import clearSelection from './clearSelection';
import composeClassnames from './composeClassnames';
import escapeRegExpString from './escapeRegExpString';
import eventHasMetaKey from './eventHasMetaKey';
import extractClassnames from './extractClassnames';
import linkIsExternal from './linkIsExternal';
import getDomainName from './getDomainName';
import startsWith from './startsWith';
import processLargeArray from './processLargeArray';
import replaceAll from './replaceAll';
import scrollToElement from './scrollToElement';
import trimWhitespace from './trimWhitespace';

export {
	clearSelection,
	composeClassnames,
	escapeRegExpString,
	eventHasMetaKey,
	extractClassnames,
	linkIsExternal,
	getDomainName,
	startsWith,
	processLargeArray,
	replaceAll,
	scrollToElement,
	trimWhitespace
};

export default {
	clearSelection,
	composeClassnames,
	escapeRegExpString,
	eventHasMetaKey,
	extractClassnames,
	linkIsExternal,
	getDomainName,
	startsWith,
	processLargeArray,
	replaceAll,
	scrollToElement,
	trimWhitespace
};



// WEBPACK FOOTER //
// ./src/util/index.js